var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"mb-button",class:{
    'mb-button--primary': _vm.type==='primary',
    'mb-button--secondary': _vm.type==='secondary',
  },attrs:{"icon":_vm.icon,"size":_vm.size,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }